import { render, staticRenderFns } from "./OffersNotMatchingToSkillList.vue?vue&type=template&id=3448bae4&scoped=true&"
import script from "./OffersNotMatchingToSkillList.vue?vue&type=script&lang=js&"
export * from "./OffersNotMatchingToSkillList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3448bae4",
  null
  
)

export default component.exports